import style from '../../styles/pages/experiencias/experienciaNuevas.module.scss';

type paragraph = {
  Paragraph: string | JSX.Element;
  secondTitle: string;
  description: string;
};

export default function Paragraph(datos: paragraph) {
  return (
    <>
      <div className={style.text}>
        <p>{datos.Paragraph}</p>
        <h2>{datos.secondTitle}</h2>
        <p>{datos.description}</p>
      </div>
    </>
  );
}
